import { render, staticRenderFns } from "./Tema2_2-1.vue?vue&type=template&id=0eee6832&"
import script from "./Tema2_2-1.vue?vue&type=script&lang=js&"
export * from "./Tema2_2-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports